import React from 'react'
import MuiPagination from '@material-ui/lab/Pagination'
import useStyles from './styles'

const Pagination = ({
  count,
  page,
  showFirstButton,
  showLastButton,
  siblingCount,
  goToPage,
  ...paginationProps
}) => {
  const classes = useStyles()

  const handleChange = (_, page) => {
    goToPage(page)
  }

  return (
    <div className={classes.wrapper}>
      <MuiPagination
        classes={{
          ul: classes.list,
        }}
        count={count}
        showFirstButton={showFirstButton}
        showLastButton={showLastButton}
        siblingCount={siblingCount}
        page={page}
        onChange={handleChange}
        {...paginationProps}
      />
    </div>
  )
}

export default Pagination
